import { SMSDataSharedUtils } from '@frontend/api-sms-data';
import { ShareInMessageVirtuosoContext, VirtuosoThreadItem } from '../../types';
import { CallBubble } from './call-bubble';
import { MessageBubble } from './message-bubble';
import { TimeDividerRow } from './time-divider-row';

type VirtuosoChatBubbleProps = {
  threadItem: VirtuosoThreadItem;
  context: ShareInMessageVirtuosoContext;
};

export const VirtuosoChatBubble = ({ threadItem, context }: VirtuosoChatBubbleProps) => {
  const { isSmsMessageItem, isCallRecordItem } = SMSDataSharedUtils.threadItemsUtils;

  if (typeof threadItem === 'string') {
    return <TimeDividerRow timestamp={new Date(threadItem)} />;
  }

  if (isSmsMessageItem(threadItem)) {
    return <MessageBubble message={threadItem.smsMessage} context={context} />;
  }

  if (isCallRecordItem(threadItem)) {
    return <CallBubble callItem={threadItem.callRecord} context={context} />;
  }

  return null;
};
